import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, InputGroup, Spinner } from "react-bootstrap";
import { FiCheckCircle, FiMail, FiRefreshCw, FiXCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import api, { BASE_URL } from "../../Utils/api";
import "./Login.css";
import "./AtivacaoEntidade.css";


const AtivacaoEntidade = () => {
  const navigate = useNavigate();
  const iniciou = useRef(false);
  const token =
    new URLSearchParams(window.location.search).get("token") || "";
  const [estado, setEstado] = useState(token ? "carregando" : "erro");
  const [mensagem, setMensagem] = useState(
    token ? "Confirmando seu cadastro..." : "Link de ativação não informado."
  );
  const [entidade, setEntidade] = useState("");
  const [email, setEmail] = useState("");
  const [reenviando, setReenviando] = useState(false);
  const [mensagemReenvio, setMensagemReenvio] = useState("");

  useEffect(() => {
    document.body.classList.add("login-page-body");
    return () => document.body.classList.remove("login-page-body");
  }, []);

  useEffect(() => {
    if (!token || iniciou.current) return;
    iniciou.current = true;

    api
      .post(`${BASE_URL}/api/auth/ativar-entidade`, { token })
      .then(({ data }) => {
        setEntidade(data?.entidade || "");
        setMensagem(
          data?.message || "O acesso à sua entidade está liberado."
        );
        setEstado("sucesso");
      })
      .catch((err) => {
        setMensagem(
          err?.response?.data?.message ||
            "Não foi possível validar este link de ativação."
        );
        setEstado("erro");
      });
  }, [token]);

  useEffect(() => {
    if (estado !== "sucesso") return undefined;
    const timer = window.setTimeout(
      () => navigate("/login", { replace: true }),
      5000
    );
    return () => window.clearTimeout(timer);
  }, [estado, navigate]);

  const reenviar = async (event) => {
    event.preventDefault();
    setReenviando(true);
    setMensagemReenvio("");
    try {
      const { data } = await api.post(
        `${BASE_URL}/api/auth/reenviar-ativacao`,
        { email }
      );
      setMensagemReenvio(data?.message || "Solicitação registrada.");
    } catch {
      setMensagemReenvio(
        "Não foi possível solicitar o reenvio neste momento."
      );
    } finally {
      setReenviando(false);
    }
  };

  return (
    <div id="login-page">
      <main className="activation-container">
        <section className="activation-card" aria-live="polite">
          {estado === "carregando" && (
            <>
              <Spinner animation="border" className="activation-spinner" />
              <h1>Ativando sua entidade</h1>
              <p>{mensagem}</p>
            </>
          )}

          {estado === "sucesso" && (
            <>
              <FiCheckCircle className="activation-icon activation-icon-success" />
              <span className="activation-eyebrow">Cadastro confirmado</span>
              <h1>Acesso liberado</h1>
              <p>{mensagem}</p>
              {entidade && (
                <div className="activation-entity">{entidade}</div>
              )}
              <small className="activation-redirect-note">
                Você será direcionado ao login em alguns segundos.
              </small>
              <Button
                className="btn-app-primary activation-primary"
                onClick={() => navigate("/login", { replace: true })}
              >
                Ir para o login
              </Button>
            </>
          )}

          {estado === "erro" && (
            <>
              <FiXCircle className="activation-icon activation-icon-error" />
              <span className="activation-eyebrow">Ativação pendente</span>
              <h1>Este link não pôde ser utilizado</h1>
              <p>{mensagem}</p>

              <Form onSubmit={reenviar} className="activation-resend">
                <Form.Label>Receber um novo link</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FiMail />
                  </InputGroup.Text>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="seu@email.com"
                    required
                  />
                </InputGroup>
                {mensagemReenvio && (
                  <Alert variant="info" className="activation-alert">
                    {mensagemReenvio}
                  </Alert>
                )}
                <Button
                  type="submit"
                  className="btn-app-primary activation-primary"
                  disabled={reenviando}
                >
                  {reenviando ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <>
                      <FiRefreshCw /> Reenviar e-mail de ativação
                    </>
                  )}
                </Button>
              </Form>

              <Button
                variant="link"
                className="activation-login-link"
                onClick={() => navigate("/login", { replace: true })}
              >
                Voltar para o login
              </Button>
            </>
          )}
        </section>
      </main>
    </div>
  );
};

export default AtivacaoEntidade;
